import { t } from '@if/core/i18n'
import { FieldError as Error } from 'react-hook-form'

export default function translateErrorCode(err: Error): string {
  if (err.type === 'required') return t('common.errors.required')
  if (err.type === 'test-Sin-type') return t('common.errors.number')
  return err.message ?? ''
}
